<template>
  <div class="account">
    <div class="account-bg"></div>
    <div class="account-logo"></div>
    <custom-input type="mobile" v-model="mobile" placeholder="请输入手机号" rules="mobile"></custom-input>
    <custom-input type="code" v-model="code" placeholder="请输入验证码" :mobile="mobile" rules="password" @getCode="handleCode" codeType="reset_psd"></custom-input>
    <!--<div class="account-button" @click="next">下一步</div>-->
    <custom-input type="password" placeholder="请输入8-16位混合密码" v-model="password"></custom-input>
    <custom-input type="password" placeholder="请确认密码" v-model="passwordConfirm"></custom-input>
    <div class="forget-warn">*密码8-16位，至少包含数字，字母，特殊符号(下划线除外)两种元素</div>
    <div class="account-button" @click="submit">确认修改</div>
    <account-dialog :isOpen="isDialogShow" @close="isDialogShow=false" :textArr="error"></account-dialog>
  </div>
</template>

<script>
  export default {
    name: "forget",
    data(){
      return{
        password:"",
        passwordConfirm:"",
        mobile:"",
        code:"",
        error:[],
        isDialogShow:false
      }
    },
    mounted(){

    },
    methods:{
      handleCode(code){
        this.code=code;
      },
      next(code){
        //验证 验证码是否正确
        this.$api.get("",{
          api:"/v1/passport/confirm_verify",
          user_login:this.mobile,
          verify_code:this.code
        },res=>{
          if(res.status===11009){
            this.$toast("验证码错误");
          }
          else if(res.status===10000){
            this.$toast("手机号未注册");
          }
          else{
            this.$store.commit('setmobile',this.mobile);
            this.$router.push({name:"forget-next",params:{mobile:this.mobile}});
          }
        })
      },
      submit(){
        this.$api.get("",{
          api:"/v1/passport/reset_password",
          user_login:this.mobile,
          user_pass:this.password,
          confirm_pass:this.passwordConfirm,
          verify_code:this.code
        },res=>{
          if(res.status===11009){
            this.$toast("验证码错误");
          }
          else if(res.status===10000){
            this.$toast("手机号未注册");
          }
          if(res.status===1){
            this.$toast("修改成功");
            window.setTimeout(()=>{
              this.$router.push("/login");
            },1000)
          }
          else{
            this.toast("修改失败");
          }
        })
      }
    }
  }
</script>

<style scoped>
  .forget-warn{
    margin:0.533rem 0.4rem 0 0.4rem;
    color:#999;
    font-size:0.373rem;
    text-shadow:-2px -2px 0.267rem rgba(12,83,155,0.31);
  }
</style>



// WEBPACK FOOTER //
// src/components/forget/forget.vue